import { BrowserRouter, Routes, Route } from 'react-router';
import TopographicBackground from './components/background/TopographicBackground';
import AppLayout from './components/layout/AppLayout';
import Hero from './components/hero/Hero';
import ProjectsSection from './components/projects/ProjectsSection';
import ChallengeView from './components/challenge/ChallengeView';
import CodingProjectsView from './components/coding/CodingProjectsView';
import WebGISView from './components/webgis/WebGISView';
import HighlightsView from './components/highlights/HighlightsView';
import styles from './App.module.css';

export default function App() {
  return (
    <BrowserRouter>
      <div className={styles.app}>
        <TopographicBackground />
        <Routes>
          <Route element={<AppLayout />}>
            <Route index element={<Hero />} />
            <Route path="projects" element={<ProjectsSection />} />
            <Route path="challenge" element={<ChallengeView />} />
            <Route path="coding" element={<CodingProjectsView />} />
            <Route path="webgis" element={<WebGISView />} />
            <Route path="highlights" element={<HighlightsView />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}
